import { useCurrency } from '../contexts/CurrencyContext';
import {
  calculatePriceWithTax,
  calculateFromPriceBreakdown,
  calculateTotalWithTax,
  formatPriceWithTax,
  formatPriceWithTaxBreakdown,
  TaxCalculation
} from '../utils/taxUtils';

export const usePriceFormat = () => {
  const { formatPrice, currency } = useCurrency();

  return {
    formatPrice,
    currency,
    // Convenience method for formatting prices with the app's fixed currency
    format: (amount: number) => formatPrice(amount),
    // Tax calculation methods
    calculatePriceWithTax,
    calculateFromPriceBreakdown,
    calculateTotalWithTax,
    // Format price with tax included
    formatWithTax: (basePrice: number, taxRate: number) => {
      return formatPriceWithTax(basePrice, taxRate, formatPrice);
    },
    // Format price with tax breakdown
    formatWithTaxBreakdown: (basePrice: number, taxRate: number) => {
      return formatPriceWithTaxBreakdown(basePrice, taxRate, formatPrice);
    }
  };
};
